import React, { useEffect } from "react";
import Contact from "./Contact";
import Aos from "aos";
import "aos/dist/aos.css";

const Location = () => {
  useEffect(() => {
    Aos.init({
      easing: "ease-in-sine",
    });
  }, []);
  return (
    <div className="container d-flex justify-content-center sectionMergin">
      <div className="sectionContainer">
        <div
          className="row"
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="col-md-12 ">
            <h2
              className=" text-center fs-1 mb-5 "
              style={{
                color: "black",
                fontWeight: "500",
                fontFamily: "Montserrat",
                fontSize: "36px",
              }}
            >
              Grow Your Business With Our Expertise
            </h2>
          </div>
        </div>

        <div className="row">
          <div
            className="col-lg-6"
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
          >
            <Contact />
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
          >
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2815.9826312873283!2d-2.2365541232597894!3d53.48710137233044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb1b994d1be3f%3A0xa0d075b508a39482!2s1602%2C%2049%20Goulden%20St%2C%20Manchester%20M4%205EN%2C%20UK!5e1!3m2!1sen!2sbd!4v1750139451511!5m2!1sen!2sbd"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="location w-100"
            ></iframe> */}
            <div className="embed-map-responsive">
              <div className="embed-map-container">
                <iframe
                  className="embed-map-frame"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  src="https://maps.google.com/maps?width=600&height=400&hl=en&q=68%20Thorn%20Court%2C%20Manchester%2C%20England%2C%20M6%205EL&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                ></iframe>
              </div>
              <style>{`.embed-map-responsive{position:relative;text-align:right;width:100%;height:0;padding-bottom:66.66666666666666%;}.embed-map-container{overflow:hidden;background:none!important;width:100%;height:100%;position:absolute;top:0;left:0;}.embed-map-frame{width:100%!important;height:100%!important;position:absolute;top:0;left:0;}`}</style>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
